let accessTokenHint: string | null = null;

export function setAccessTokenHint(token: string | null): void {
  accessTokenHint = token;
}

export function consumeAccessTokenHint(): string | null {
  const hint = accessTokenHint;
  accessTokenHint = null;
  return hint;
}
